import React, { useContext } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useNonExchangeDayService from '../../../app/services/hooks/useNonExchangeDayService';

interface Props {
    nonExchangeDayId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const NonExchangeDaySwitchChange = ({ nonExchangeDayId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeNonExchangeDay, fetchingActiveNonExchangeDay } = useNonExchangeDayService();

    const active = (value: boolean) => {
        setChecked(value);

        activeNonExchangeDay(nonExchangeDayId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={nonExchangeDayId} callback={active} />;
};

export default NonExchangeDaySwitchChange; 